import { authHeader } from '@/utils';
import axios from 'axios';

/* URL API */
//produccion --> https://prod-api-estudiantes-externos.utic.ecosur.mx/
//desarrollo --> https://dev-api-estudiantes-externos.utic.ecosur.mx/

const multipartClient = axios.create({
  baseURL: process.env.REACT_APP_URL_API,
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: authHeader(),
  },
});

export default multipartClient;
